import { useTabsComponents } from '@/next/utils/useTabsComponents';
import { Layer, useViewer } from '@/stores/viewer';
import { cn } from '@/utils/classname';
import { LayeringTab } from './LayeringTab';
import { PointCloudTab } from './PointCloudTab/PointCloudTab';
import { TilesetStatisticsTab } from './TilesetStatisticsTab';

export interface PointCloudSettingsMenuProps {
  layer: Layer;
}

export const PointCloudSettingsMenu = ({ layer }: PointCloudSettingsMenuProps) => {
  const enabledStatistics = useViewer(state => state.viewer3DSettings.enabledStatistics);
  const { Tabs, TabsList, TabsTrigger, TabsContent } = useTabsComponents();

  return (
    <div className={cn('w-full flex flex-col')}>
      <Tabs defaultValue={enabledStatistics ? 'layering' : 'point_cloud'}>
        <TabsList>
          <TabsTrigger value="layering">Layering</TabsTrigger>
          <TabsTrigger value="point_cloud">Point cloud</TabsTrigger>
          {enabledStatistics && <TabsTrigger value="statistics">Statistics</TabsTrigger>}
        </TabsList>

        <TabsContent value="layering">
          <LayeringTab layer={layer} />
        </TabsContent>
        <TabsContent value="point_cloud">
          <PointCloudTab layer={layer} />
        </TabsContent>
        {enabledStatistics && (
          <TabsContent value="statistics">
            <TilesetStatisticsTab layer={layer} />
          </TabsContent>
        )}
      </Tabs>
    </div>
  );
};
